import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';
import dayjs from 'dayjs';

@Component({
	selector: 'formly-field-input',
	template: `
		<vp-date-picker
			[calendarData]="props['calendarData'] || null"
			[config]="{
				defaultDate: formControl.value || props['defaultDate'] || null,
				minDate: props['minDate'] || today,
				maxDate: props['maxDate'] || null,
				showMonths: props['showMonths'] || 1,
			}"
			[inputConfig]="{
				disabled: props.disabled,
				hasError: showError,
				icon: props['icon'],
				iconPosition: props['iconPosition'],
				isValid: formControl.valid,
				name: field.id,
				placeholder: props.placeholder,
				readonly: props.readonly,
				defaultStyle: props['defaultStyle'] || true,
				required: props.required,
			}"
			[isLoading]="props['isLoading']"
			[labelSettings]="{
				text: null,
				position: null,
			}"
			(emitDates)="onEmitDates($event)"
		/>
	`,
	standalone: false,
})
export class DateInputComponent extends FieldType<FieldTypeConfig> {
	today: string = dayjs().format('YYYY-MM-DD');

	onEmitDates(dates: Date[]): void {
		this.formControl.setValue(
			dates?.[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
		);
		this.formControl.markAsTouched();
	}
}
